export default __webpack_public_path__ + "static/media/artxets_img.5faf8cd0.png";